import { MutationCache, QueryClient, type DefaultOptions } from '@tanstack/react-query';

/**
 * The app's query cache. u44: any saved change may affect "รอเผยแพร่", so that one small query
 * refreshes after every successful save.
 */
export function createQueryClient(defaultOptions: DefaultOptions = {}): QueryClient {
  const client: QueryClient = new QueryClient({
    defaultOptions,
    mutationCache: new MutationCache({
      onSuccess: () => void client.invalidateQueries({ queryKey: ['publish-state'] }),
    }),
  });
  return client;
}
